<nav class="sidebar" [class.sidebar--collapsed]="collapsed()" aria-label="Observability catalog">
  <div class="sidebar__header">
    <div class="sidebar__brand">
      <img
        class="sidebar__logo"
        src="/images/icon-192x192.png"
        width="112"
        height="112"
        alt="AgVantis"
        (click)="onLogoClick($event)"
      />
    </div>
    <button
      matIconButton
      type="button"
      [attr.aria-label]="collapsed() ? 'Expand navigation' : 'Collapse navigation'"
      [matTooltip]="collapsed() ? 'Expand navigation' : 'Collapse navigation'"
      matTooltipPosition="right"
      (click)="collapseToggled.emit()"
    >
      <mat-icon>{{ collapsed() ? 'chevron_right' : 'chevron_left' }}</mat-icon>
    </button>
  </div>

  <div class="sidebar__items">
    @for (team of teams(); track team) {
      <p
        class="sidebar__team"
        [matTooltip]="collapsed() ? team : ''"
        [matTooltipDisabled]="!collapsed()"
        matTooltipPosition="right"
      >
        <span class="sidebar__team-name">{{ team }}</span>
      </p>
      @for (item of itemsForTeam(team); track item.rowKey) {
        @if (routerLinkFor(item); as link) {
          <a
            class="sidebar__item"
            [routerLink]="link"
            routerLinkActive="sidebar__item--active"
            [routerLinkActiveOptions]="{ exact: true }"
            [matTooltip]="collapsed() ? item.title : item.description"
            matTooltipPosition="right"
          >
            @if (svgIconFor(item); as svgIcon) {
              <mat-icon [svgIcon]="svgIcon" />
            } @else {
              <mat-icon>{{ iconFor(item) }}</mat-icon>
            }
            @if (!collapsed()) {
              <span class="sidebar__label">{{ item.title }}</span>
            }
          </a>
        } @else {
          <button
            type="button"
            class="sidebar__item"
            [matTooltip]="collapsed() ? item.title : item.description"
            matTooltipPosition="right"
            (click)="open(item, $event)"
          >
            @if (svgIconFor(item); as svgIcon) {
              <mat-icon [svgIcon]="svgIcon" />
            } @else {
              <mat-icon>{{ iconFor(item) }}</mat-icon>
            }
            @if (!collapsed()) {
              <span class="sidebar__label">{{ item.title }}</span>
            }
          </button>
        }
      }
    }
  </div>
</nav>

@if (clippyVisible()) {
  <aside class="clippy" [class.clippy--leaving]="clippyLeaving()" role="status">
    <div class="clippy__bubble">
      <button class="clippy__close" type="button" aria-label="Dismiss Clippy" (click)="hideClippy()">
        <mat-icon>close</mat-icon>
      </button>
      <p>{{ clippyMessage() }}</p>
    </div>
    <svg class="clippy__figure" viewBox="0 -14 200 250" aria-hidden="true">
      <defs>
        <linearGradient id="clippyWire" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0" stop-color="#6c6b9e" />
          <stop offset="0.45" stop-color="#b8b7de" />
          <stop offset="1" stop-color="#7a79ab" />
        </linearGradient>
        <radialGradient id="clippyEye" cx="0.4" cy="0.35" r="0.7">
          <stop offset="0" stop-color="#ffffff" />
          <stop offset="0.75" stop-color="#f1f1f4" />
          <stop offset="1" stop-color="#c9c9d3" />
        </radialGradient>
      </defs>
      <ellipse cx="114" cy="226" rx="44" ry="6" fill="#000" opacity="0.28" />
      <path
        d="M142 120V192c0 34-58 34-58 0V44c0-40 40-40 40 0V178c0 20-24 20-24 0V112"
        fill="none"
        stroke="url(#clippyWire)"
        stroke-width="9"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M87 150V48c0-30 20-36 30-24"
        fill="none"
        stroke="#e4e3f6"
        stroke-width="2.4"
        stroke-linecap="round"
        opacity="0.75"
      />
      <g>
        <ellipse cx="104" cy="22" rx="40" ry="8.5" fill="#241c16" />
        <path d="M72 20c3-26 15-34 32-34s30 9 33 34c-19 6-46 6-65 0z" fill="#3a2d23" />
        <path d="M92-6c4 5 8 7 12 7s8-2 12-7c-4 3-8 5-12 5s-8-2-12-5z" fill="#2a2118" />
        <path d="M76 17h57c-2 5-15 7-28 7s-27-2-29-7z" fill="#7a2432" />
      </g>
      <path d="M52 66c9-12 26-15 40-8" fill="none" stroke="#111" stroke-width="7" stroke-linecap="round" />
      <path d="M118 58c13-6 28-3 36 8" fill="none" stroke="#111" stroke-width="7" stroke-linecap="round" />
      <g>
        <ellipse cx="74" cy="92" rx="21" ry="17" fill="url(#clippyEye)" stroke="#9a9aae" stroke-width="1.2" />
        <ellipse cx="134" cy="92" rx="21" ry="17" fill="url(#clippyEye)" stroke="#9a9aae" stroke-width="1.2" />
        <ellipse cx="80" cy="95" rx="8.5" ry="9.5" fill="#0d0d12" />
        <ellipse cx="140" cy="95" rx="8.5" ry="9.5" fill="#0d0d12" />
        <circle cx="83" cy="91" r="2.6" fill="#fff" />
        <circle cx="143" cy="91" r="2.6" fill="#fff" />
      </g>
      <g transform="translate(14 136) rotate(-22)">
        <circle cx="26" cy="26" r="21" fill="#c5e6f4" fill-opacity="0.45" stroke="#e2b15a" stroke-width="4.5" />
        <path d="M15 16c5-5 12-7 18-4" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" opacity="0.85" />
        <path d="M41 43l16 22" fill="none" stroke="#6b4324" stroke-width="6" stroke-linecap="round" />
      </g>
    </svg>
  </aside>
}
